import { createBrowserRouter } from "react-router-dom";
import App, { appLoader } from "../App";
import AuthContainer from "../pages/containers/AuthContainer";
import LoginPage from "../pages/auth/login_page";
import RegisterPage from "../pages/auth/register_page";
import DashboardContainer, {
  containerLoader,
} from "../pages/containers/DashboardContainer";
import OverviewPage, {
  overviewLoader,
} from "../pages/dashboard/overview/overview_page";
import PatientsPage, {
  patientsLoader,
} from "../pages/dashboard/patients/patients_page";
import { ErrorElement } from "../components/ErrorElement";
import PatientPage, { indexLoader } from "../pages/dashboard/patients/pages";
import OrderPage, {
  orderLoader,
} from "../pages/dashboard/patients/pages/orders";
import PatientInfoPage, {
  patientLoader,
} from "../pages/dashboard/patients/pages/patient-info";
import AllOrdersPage, {
  allOrdersLoader,
} from "../pages/dashboard/orders/orders_page";
import {
  IndexPage,
  facilityIndexLoader,
} from "../pages/dashboard/facility/pages";
import {
  FacilityPage,
  facilityLoader,
} from "../pages/dashboard/facility/facility_page";
import {
  DoctorsPage,
  facilityDoctorsLoader,
} from "../pages/dashboard/facility/pages/doctors_page";
import {
  NotificationsPage,
  notificationLoader,
} from "../pages/dashboard/notifications/notifications_page";
import {
  SettingsPage,
  parentSettingsLoader,
  settingsLoader,
} from "../pages/dashboard/settings/pages/index";
import {
  InvoicesPage,
  invoicesLoader,
} from "../pages/dashboard/invoices/invoice_page";
import ForgotPasswordPage from "../pages/auth/forgot-password_page";
import ChangePasswordPage from "../pages/auth/change-password_page";
import { DeactivatedAccountPage } from "../pages/deactivated_page";
import {
  InvoiceItemPage,
  invoiceItemLoader,
} from "../pages/dashboard/invoices/[id]";
import RequestAccountPage, {
  requestAccountLoader,
} from "../pages/auth/request_account_page";
import RequestSuccess from "../pages/auth/request_success";
import { ConfirmEmail } from "../pages/auth/confirm-email";
import RegisterDoctorPage from "../pages/auth/register-doctor_page";
import {
  MessagesPage,
  messagesLoader,
} from "../pages/dashboard/messages/messages_page";
import {
  MessageItemPage,
  messageItemLoader,
} from "../pages/dashboard/messages/message_item_page";
import {
  OrderItemPage,
  orderItemLoader,
} from "../pages/dashboard/orders/order_item_page";
import { GetSupportPage } from "../pages/dashboard/support/support_page";
import {
  SubscriptionPage,
  subscriptionLoader,
} from "../pages/dashboard/subscription/subscription_page";
import TeleDashboard from "../pages/dashboard/telemedicine/children/dashboard/page";
import TeleLayout from "../pages/dashboard/telemedicine/_layout";
import CMSTreatmentsPage from "../pages/dashboard/cms/pages/treatments_page";
import CMSProductsPage from "../pages/dashboard/cms/pages/products_page";
import CMSTestimonialsPage from "../pages/dashboard/cms/pages/testimonials_page";
import CMSLayout, { cmsLoader } from "../pages/dashboard/cms/cms_layout";

import TeleAccountSettings from "../pages/dashboard/telemedicine/children/account_settings/page";
import TeleCalendar from "../pages/dashboard/telemedicine/children/my_calendar/page";
import TeleMeetingHistory from "../pages/dashboard/telemedicine/children/meeting_history/page";
import TeleHealthRecords from "../pages/dashboard/telemedicine/children/health_records/page";
import TeleCarePlans from "../pages/dashboard/telemedicine/children/care_plans/page";
import AgoraClient, {
  agoraLoader,
} from "../pages/dashboard/telemedicine/_agoraClient";
import AvailabilityPage from "../pages/dashboard/telemedicine/children/my_calendar/children/availability";
import CalendarLayout from "../pages/dashboard/telemedicine/children/my_calendar/_layout";
import MeetingContainer from "../pages/dashboard/telemedicine/children/meeting/meeting_container";
import GuestSetUp from "../pages/dashboard/telemedicine/children/guest/setup";
import GuestMeetingRoom from "../pages/dashboard/telemedicine/compomnents/GuestMeetingRoom";
import WaitingRoom from "../pages/dashboard/telemedicine/children/waiting_room/page";
import RefillRequestsPage, {
  refillRequestsLoader,
} from "../pages/dashboard/refill-requests/refill_requests_page";
import ApprovedRefillRequestsPage, {
  approvedRefillRequestsLoader,
} from "../pages/dashboard/refill-requests/approved_refill_requests";
import DeclinedRefillRequestsPage, {
  declinedRefillRequestsLoader,
} from "../pages/dashboard/refill-requests/declined_refill_requests";
import RefillRequestItemPage, {
  refillRequestItemLoader,
} from "../pages/dashboard/refill-requests/refill_request_item";
import EditOrderPage, {
  editOrderLoader,
} from "../pages/dashboard/refill-requests/edit_order_page";
import FormsPage, {
  formsLoader,
} from "../pages/dashboard/patients/pages/forms";
import InstantSetUp from "../pages/dashboard/telemedicine/children/instant/setup";
import PatientNotes from "../pages/dashboard/patients/pages/patient_notes";
import InstantMeetingContainer from "../pages/dashboard/telemedicine/children/meeting/instant_meeting_container";
import InstantInviteeMeetingRoom from "../pages/dashboard/telemedicine/compomnents/InstantInviteeMeetingRoom";
import { SettingsContainer } from "../pages/dashboard/settings/settings_page";
import {
  TreatmentSetup,
  treatmentSetupLoader,
} from "../pages/dashboard/settings/pages/treatment_setup_page";
import {
  TreatmentProvidersPage,
  treatmentProvidersLoader,
} from "../pages/dashboard/settings/pages/treatment_setup_pages/treatment_providers";
import {
  TreatmentsPage,
  treatmentsLoader,
} from "../pages/dashboard/settings/pages/treatment_setup_pages/treatments_page";
import {
  newTreatmentLoader,
  NewTreatmentPage,
} from "../pages/dashboard/settings/pages/treatment_setup_pages/new_treatment_page";
import {
  EditTreatmentPage,
  editTreatmentLoader,
} from "../pages/dashboard/settings/pages/treatment_setup_pages/edit_treatment_page";
import ConsultationPage, {
  consultationLoader,
} from "../pages/dashboard/telemedicine/children/consultations/page";

import {
  AllConsultationsPage,
  allConsultationsLoader,
} from "../pages/dashboard/telemedicine/children/consultations/all_consultations_page";
import {
  PendingConsultationsPage,
  pendingConsultationsLoader,
} from "../pages/dashboard/telemedicine/children/consultations/pending_consultations";
import PrescriptionPage from "../pages/dashboard/telemedicine/children/prescriptions/page"; // prescriptionLoader,
import {
  ConsultationItemPage,
  consultationItemLoader,
} from "../pages/dashboard/telemedicine/children/consultations/consultation_item_page";
import ThemePage from "../pages/dashboard/settings/pages/theme/theme_page";
import {
  ConsultationsLayout,
  consultationsLayoutLoader,
} from "../pages/dashboard/telemedicine/children/consultations/consultations_layout";
import { EarningsPage, earningsLoader } from "../pages/dashboard/earnings";
import {
  EarningsOverviewPage,
  earningsOverviewLoader,
} from "../pages/dashboard/earnings/pages/overview_page";
import {
  PaymentsPage,
  paymentsLoader,
} from "../pages/dashboard/earnings/pages/payments_page";
import {
  PayoutsPage,
  payoutsLoader,
} from "../pages/dashboard/earnings/pages/payouts_page";
import {
  InvoicesEarningsPage,
  invoicesEarningsLoader,
} from "../pages/dashboard/earnings/pages/invoices_page";
import {
  CustomersEarningsPage,
  customersEarningsLoader,
} from "../pages/dashboard/earnings/pages/customers_page";
import {
  CustomerPage,
  customerLoader,
} from "../pages/dashboard/earnings/pages/customer_page";
import { AdminOverrideAccess } from "../pages/auth/admin_override_access";
import {
  medSpasLoader,
  MedSpasPage,
} from "../pages/dashboard/facility/pages/med_spas_page";
import RescheduleRequests from "../pages/dashboard/telemedicine/children/reschedule_requests/requests";
import OrderRxsPage, {
  orderRxsLoader,
} from "../pages/dashboard/orders/order_rxs_page";
import AcceptInvitePage from "../pages/auth/accept_invite";
import {
  subscriptionsLoader,
  SubscriptionsPage,
} from "../pages/dashboard/earnings/pages/subscriptions_page";
import VitalRxLoginPage from "../pages/auth/vitalRx/login_page";
import RequestVitalRxAccountPage from "../pages/auth/vitalRx/request_account";
import ResetPasswordPage from "../pages/auth/vitalRx/reset_password";
import PasswordChangePage from "../pages/auth/vitalRx/password_change";
import HWLoginPage from "../pages/auth/healthwealth/login_page";
import ApiPage from "../pages/dashboard/settings/pages/apis/api_page";
import ApiKeysPage from "../pages/dashboard/settings/pages/apis/api_keys_page";
import ApiDocPage from "../pages/dashboard/settings/pages/apis/api_documentation_page";

const url = window.location.href;

// temporary usage will be changed
const isVitalRx = url.includes("vitalrx");
const isHealthWealth = url.includes("healthwealth");

console.log("At", url);

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      loader: appLoader,
      children: [
        {
          path: "auth",
          element: <AuthContainer />,
          children: [
            {
              path: "login",
              element: isVitalRx ? (
                <VitalRxLoginPage />
              ) : isHealthWealth ? (
                <HWLoginPage />
              ) : (
                <LoginPage />
              ),
            },
            {
              path: "login-vitalrx",
              element: <VitalRxLoginPage />,
            },
            {
              path: "register",
              element: <RegisterPage />,
            },
            {
              path: "register-doctor",
              element: <RegisterDoctorPage />,
            },
            {
              path: "request-success",
              element: <RequestSuccess />,
            },
            {
              path: "request",
              element: isVitalRx ? (
                <RequestVitalRxAccountPage />
              ) : (
                <RequestAccountPage />
              ),
              //loader: requestAccountLoader,
            },
            {
              path: "request-vitalrx",
              element: <RequestVitalRxAccountPage />,
              //loader: requestAccountLoader,
            },
            {
              path: "forgot-password",
              element: isVitalRx ? (
                <ResetPasswordPage />
              ) : (
                <ForgotPasswordPage />
              ),
            },
            {
              path: "change-password",
              element: isVitalRx ? (
                <PasswordChangePage />
              ) : (
                <ChangePasswordPage />
              ),
            },
            // {
            //   path: "confirm-email",
            //   element: <ConfirmEmail />,
            // },
            {
              path: "admin",
              element: <AdminOverrideAccess />,
            },
            {
              path: "accept-invite",
              element: <AcceptInvitePage />,
            },
          ],
        },
        {
          path: "deactivated",
          element: <DeactivatedAccountPage />,
        },
        {
          path: "dashboard",
          element: <DashboardContainer />,
          errorElement: <ErrorElement />,
          loader: containerLoader,
          children: [
            {
              path: "overview",
              element: <OverviewPage />,
              errorElement: <ErrorElement />,
              loader: overviewLoader,
            },
            {
              path: "orders",
              element: <AllOrdersPage />,
              errorElement: <ErrorElement />,
              loader: allOrdersLoader,
              children: [
                {
                  path: ":id",
                  element: <OrderItemPage />,
                  loader: orderItemLoader,
                },
              ],
            },
            {
              path: "orders/:id/rxs",
              element: <OrderRxsPage />,
              errorElement: <ErrorElement />,
              loader: orderRxsLoader,
            },
            {
              path: "billing",
              element: <SubscriptionPage />,
              errorElement: <ErrorElement />,
              loader: subscriptionLoader,
            },
            {
              path: "support",
              element: <GetSupportPage />,
              errorElement: <ErrorElement />,
            },
            {
              path: "cms",
              element: <CMSLayout />,
              errorElement: <ErrorElement />,
              loader: cmsLoader,
              children: [
                {
                  path: "treatments",
                  element: <CMSTreatmentsPage />,
                  errorElement: <ErrorElement />,
                },
                {
                  path: "products",
                  element: <CMSProductsPage />,
                  errorElement: <ErrorElement />,
                },
                {
                  path: "testimonials",
                  element: <CMSTestimonialsPage />,
                  errorElement: <ErrorElement />,
                },
              ],
            },
            {
              path: "patients",
              element: <PatientsPage />,
              errorElement: <ErrorElement />,
              loader: patientsLoader,
            },
            {
              path: "patients/:id",
              element: <PatientPage />,
              loader: indexLoader,
              errorElement: <ErrorElement />,
              children: [
                {
                  path: "",
                  element: <PatientInfoPage />,
                  loader: patientLoader,
                  errorElement: <ErrorElement />,
                },
                {
                  path: "notes",
                  element: <PatientNotes />,
                  loader: patientLoader,
                  errorElement: <ErrorElement />,
                },
                {
                  path: "orders",
                  element: <OrderPage />,
                  loader: orderLoader,
                  errorElement: <ErrorElement />,
                  children: [
                    {
                      path: ":id",
                      element: <OrderItemPage />,
                      loader: orderItemLoader,
                    },
                  ],
                },
                {
                  path: "forms",
                  element: <FormsPage />,
                  loader: formsLoader,
                  errorElement: <ErrorElement />,
                },
              ],
            },
            {
              path: "facility",
              element: <FacilityPage />,
              errorElement: <ErrorElement />,
              loader: facilityLoader,
              children: [
                {
                  path: "",
                  element: <IndexPage />,
                  errorElement: <ErrorElement />,
                  loader: facilityIndexLoader,
                },
                {
                  path: "members",
                  element: <DoctorsPage />,
                  errorElement: <ErrorElement />,
                  loader: facilityDoctorsLoader,
                },
                {
                  path: "clinic-referrals",
                  element: <MedSpasPage />,
                  errorElement: <ErrorElement />,
                  loader: medSpasLoader,
                },
              ],
            },
            {
              path: "invoices",
              element: <InvoicesPage />,
              errorElement: <ErrorElement />,
              loader: invoicesLoader,
            },
            {
              path: "invoices/:id",
              element: <InvoiceItemPage />,
              errorElement: <ErrorElement />,
              loader: invoiceItemLoader,
            },
            {
              path: "notifications",
              element: <NotificationsPage />,
              errorElement: <ErrorElement />,
              loader: notificationLoader,
            },
            {
              path: "messages",
              element: <MessagesPage />,
              errorElement: <ErrorElement />,
              loader: messagesLoader,
              children: [
                {
                  path: "order/:id",
                  element: <OrderItemPage />,
                  loader: orderItemLoader,
                },
              ],
            },
            {
              path: "earnings",
              element: <EarningsPage />,
              errorElement: <ErrorElement />,
              loader: earningsLoader,
              children: [
                {
                  path: "",
                  element: <EarningsOverviewPage />,
                  errorElement: <ErrorElement />,
                  loader: earningsOverviewLoader,
                },
                {
                  path: "payments",
                  element: <PaymentsPage />,
                  errorElement: <ErrorElement />,
                  loader: paymentsLoader,
                },
                {
                  path: "payouts",
                  element: <PayoutsPage />,
                  errorElement: <ErrorElement />,
                  loader: payoutsLoader,
                },
                // {
                //   path: "invoices",
                //   element: <InvoicesEarningsPage />,
                //   errorElement: <ErrorElement />,
                //   loader: invoicesEarningsLoader,
                // },
                {
                  path: "subscriptions",
                  element: <SubscriptionsPage />,
                  errorElement: <ErrorElement />,
                  loader: subscriptionsLoader,
                },
                {
                  path: "customers",
                  element: <CustomersEarningsPage />,
                  errorElement: <ErrorElement />,
                  loader: customersEarningsLoader,
                },
                // {
                //   path: "customers/:id",
                //   element: <CustomerPage />,
                //   errorElement: <ErrorElement />,
                //   loader: customerLoader,
                // },
              ],
            },
            {
              path: "refill-requests",
              element: <RefillRequestsPage />,
              errorElement: <ErrorElement />,
              loader: refillRequestsLoader,
              children: [
                {
                  path: ":id",
                  element: <RefillRequestItemPage />,
                  errorElement: <ErrorElement />,
                  loader: refillRequestItemLoader,
                },
                {
                  path: ":id/order/:orderId",
                  element: <EditOrderPage />,
                  errorElement: <ErrorElement />,
                  loader: editOrderLoader,
                },
              ],
            },
            {
              path: "refill-requests/approved",
              element: <ApprovedRefillRequestsPage />,
              errorElement: <ErrorElement />,
              loader: approvedRefillRequestsLoader,
              children: [
                {
                  path: ":id",
                  element: <RefillRequestItemPage />,
                  errorElement: <ErrorElement />,
                  loader: refillRequestItemLoader,
                },
              ],
            },
            {
              path: "refill-requests/declined",
              element: <DeclinedRefillRequestsPage />,
              errorElement: <ErrorElement />,
              loader: declinedRefillRequestsLoader,
              children: [
                {
                  path: ":id",
                  element: <RefillRequestItemPage />,
                  errorElement: <ErrorElement />,
                  loader: refillRequestItemLoader,
                },
              ],
            },
            {
              path: "settings",
              element: <SettingsContainer />,
              errorElement: <ErrorElement />,
              loader: parentSettingsLoader,
              children: [
                {
                  path: "personal-info",
                  element: <SettingsPage />,
                  errorElement: <ErrorElement />,
                  loader: settingsLoader,
                },
                {
                  path: "theme",
                  element: <ThemePage />,
                  errorElement: <ErrorElement />,
                  loader: containerLoader,
                },
                {
                  path: "apis",
                  element: <ApiPage />,
                  errorElement: <ErrorElement />,
                  loader: parentSettingsLoader,
                  children: [
                    {
                      path: "",
                      element: <ApiKeysPage />,
                      errorElement: <ErrorElement />,
                      loader: parentSettingsLoader,
                    },
                    {
                      path: "documentation",
                      element: <ApiDocPage />,
                      errorElement: <ErrorElement />,
                      loader: parentSettingsLoader,
                    },
                  ],
                },
                {
                  path: "treatment-setup",
                  element: <TreatmentSetup />,
                  errorElement: <ErrorElement />,
                  loader: treatmentSetupLoader,
                  children: [
                    {
                      path: "",
                      element: <TreatmentProvidersPage />,
                      errorElement: <ErrorElement />,
                      loader: treatmentProvidersLoader,
                    },
                    {
                      path: "treatments",
                      element: <TreatmentsPage />,
                      errorElement: <ErrorElement />,
                      loader: treatmentsLoader,
                    },
                    {
                      path: "treatments/new",
                      element: <NewTreatmentPage />,
                      errorElement: <ErrorElement />,
                      loader: newTreatmentLoader,
                    },
                    {
                      path: "treatments/:id",
                      element: <EditTreatmentPage />,
                      errorElement: <ErrorElement />,
                      loader: editTreatmentLoader,
                    },
                  ],
                },
              ],
            },
            {
              path: "telemedicine",
              element: <AgoraClient />,
              errorElement: <ErrorElement />,
              loader: agoraLoader,
              children: [
                {
                  path: "",
                  element: <TeleDashboard />,
                  errorElement: <ErrorElement />,
                  loader: consultationLoader,
                },
                {
                  path: "settings",
                  element: <TeleAccountSettings />,
                },
                {
                  path: "calendar",
                  element: <CalendarLayout />,
                  children: [
                    {
                      path: "",
                      element: <TeleCalendar />,
                      loader: patientsLoader,
                    },
                    {
                      path: "availability",
                      element: <AvailabilityPage />,
                    },
                  ],
                },
                {
                  path: "reschedule",
                  element: <RescheduleRequests />,
                },
                {
                  path: "history",
                  element: <TeleMeetingHistory />,
                },
                {
                  path: "health_records",
                  element: <TeleHealthRecords />,
                },
                {
                  path: "care_plans",
                  element: <TeleCarePlans />,
                },
                {
                  path: "waiting_room",
                  element: <WaitingRoom />,
                },
                {
                  path: "consultations",
                  element: <ConsultationsLayout />,
                  errorElement: <ErrorElement />,
                  loader: consultationsLayoutLoader,
                  children: [
                    {
                      path: "",
                      element: <ConsultationPage />,
                      errorElement: <ErrorElement />,
                      loader: consultationLoader,
                    },
                    {
                      path: "all",
                      element: <AllConsultationsPage />,
                      errorElement: <ErrorElement />,
                      loader: allConsultationsLoader,
                    },
                    {
                      path: "pending",
                      element: <PendingConsultationsPage />,
                      errorElement: <ErrorElement />,
                      loader: pendingConsultationsLoader,
                    },
                    {
                      path: ":id",
                      element: <ConsultationItemPage />,
                      errorElement: <ErrorElement />,
                      loader: consultationItemLoader,
                    },
                  ],
                },
                {
                  path: "prescriptions",
                  element: <PrescriptionPage />,
                  // errorElement: <ErrorElement />,
                  // loader: prescriptionLoader,
                },
                // {
                //   path: "meeting",
                //   element: <MeetingContainer />
                // }
              ],
            },
          ],
        },
        {
          path: "dashboard/telemedicine/meeting",
          element: <MeetingContainer />,
          loader: settingsLoader,
        },
        {
          path: "dashboard/telemedicine/meeting/instant",
          element: <InstantMeetingContainer />,
          loader: settingsLoader,
        },
      ],
    },
    {
      path: "telemedicine/meeting/invite/guest/:id", // https://nova.careapps.net/telemedicine/meeting/invite/guest/16
      element: <GuestSetUp />,
    },
    {
      path: "telemedicine/meeting/invite/instant/:id", // https://nova.careapps.net/telemedicine/meeting/invite/instant/16
      element: <InstantSetUp />,
    },
    {
      path: "telemedicine/meeting/guest",
      element: <GuestMeetingRoom />,
    },
    {
      path: "telemedicine/meeting/instant",
      element: <InstantInviteeMeetingRoom />,
    },
  ],
  {
    basename: "/clinic",
  },
);

export default router;
